/**
 * List of permissions that are supported in the project.
 *
 * For single word permissions retrieved from backend 'default' is added as the subject, e.g. `default:impersonate`.
 *
 * NOTE: the `manage` action is a name that comes from "@casl/ability" (the library we use to manage user permissions) that signifies all CRUD actions. It will *override* every other action specified for the subject.
 * @see https://casl.js.org/v6/en/guide/intro#basics
 */
export var PermissionsEnum = /*#__PURE__*/ function (PermissionsEnum) {
    PermissionsEnum["Impersonate"] = "default:impersonate";
    PermissionsEnum["ViewDirectPlansAndPackages"] = "plan_direct:view";
    PermissionsEnum["ViewPartnerPlansAndPackages"] = "plan_partner:view";
    PermissionsEnum["PackageChange"] = "package:change";
    PermissionsEnum["VisibilityPackage"] = "package:visibility";
    PermissionsEnum["ViewUsers"] = "user:view";
    PermissionsEnum["ViewActivityLog"] = "activity_log:view";
    PermissionsEnum["CreateAffiliateLink"] = "affiliate_link:create";
    PermissionsEnum["DeleteAffiliateLink"] = "affiliate_link:delete";
    PermissionsEnum["ModifyAffiliateLink"] = "affiliate_link:modify";
    PermissionsEnum["ViewAffiliateLink"] = "affiliate_link:view";
    PermissionsEnum["CreateCoupon"] = "coupon:create";
    PermissionsEnum["ModifyCoupon"] = "coupon:modify";
    PermissionsEnum["ViewCoupon"] = "coupon:view";
    PermissionsEnum["DeleteCoupon"] = "coupon:delete";
    PermissionsEnum["CreateDNS"] = "dns:create";
    PermissionsEnum["DeleteDNS"] = "dns:delete";
    PermissionsEnum["ModifyDNS"] = "dns:modify";
    PermissionsEnum["ViewDNS"] = "dns:view";
    PermissionsEnum["CreateGateway"] = "gateway:create";
    PermissionsEnum["DeleteGateway"] = "gateway:delete";
    PermissionsEnum["ModifyGateway"] = "gateway:modify";
    PermissionsEnum["ViewGateway"] = "gateway:view";
    PermissionsEnum["DeleteMember"] = "member:delete";
    PermissionsEnum["InviteMember"] = "member:invite";
    PermissionsEnum["ModifyMember"] = "member:modify";
    PermissionsEnum["ViewMember"] = "member:view";
    PermissionsEnum["CreateOrder"] = "order:create";
    PermissionsEnum["ModifyOrder"] = "order:modify";
    PermissionsEnum["ViewOrder"] = "order:view";
    PermissionsEnum["ViewCardDetails"] = "order:card-details:view";
    PermissionsEnum["CreateOrganization"] = "organization:create";
    PermissionsEnum["DeleteOrganization"] = "organization:delete";
    PermissionsEnum["ModifyOrganization"] = "organization:modify";
    PermissionsEnum["ViewOrganization"] = "organization:view";
    PermissionsEnum["ModifyOrganizationFeature"] = "organization_feature:modify";
    PermissionsEnum["ModifyContactAndBillingInfoForOrganization"] = "contact_and_billing_info_for_organization:modify";
    PermissionsEnum["ViewPayment"] = "payment:view";
    PermissionsEnum["ChangePlan"] = "plan:change";
    PermissionsEnum["ViewPlan"] = "plan:view";
    PermissionsEnum["ManagePlanDirect"] = "plan_direct:manage";
    PermissionsEnum["ManagePlanPartner"] = "plan_partner:manage";
    PermissionsEnum["CreatePlanItemType"] = "plan_item_type:create";
    PermissionsEnum["DeletePlanItemType"] = "plan_item_type:delete";
    PermissionsEnum["ModifyPlanItemType"] = "plan_item_type:modify";
    PermissionsEnum["ViewPlanItemType"] = "plan_item_type:view";
    PermissionsEnum["CreateRefund"] = "refund:create";
    PermissionsEnum["ManageRefund"] = "refund:manage";
    PermissionsEnum["ViewRefund"] = "refund:view";
    PermissionsEnum["DeleteServer"] = "server:delete";
    PermissionsEnum["ViewServer"] = "server:view";
    PermissionsEnum["ManageServerGateway"] = "server_gateway:management";
    PermissionsEnum["CancelSubscription"] = "subscription:cancel";
    PermissionsEnum["TerminateSubscription"] = "subscription:terminate";
    PermissionsEnum["ModifySubscription"] = "subscription:modify";
    PermissionsEnum["ViewSubscription"] = "subscription:view";
    PermissionsEnum["CreateTeam"] = "team:create";
    PermissionsEnum["DeleteTeam"] = "team:delete";
    PermissionsEnum["ModifyTeam"] = "team:modify";
    PermissionsEnum["ViewTeam"] = "team:view";
    PermissionsEnum["CreateUser"] = "user:create";
    PermissionsEnum["DeleteUser"] = "user:delete";
    PermissionsEnum["InviteUser"] = "user:invite";
    PermissionsEnum["ModifyUser"] = "user:modify";
    PermissionsEnum["CreatePartner"] = "partner:create";
    PermissionsEnum["ModifyPartner"] = "partner:modify";
    PermissionsEnum["ViewPartner"] = "partner:view";
    PermissionsEnum["DeletePartner"] = "partner:delete";
    PermissionsEnum["ResellersManagement"] = "resellers:manage";
    PermissionsEnum["PermissionGroupManagement"] = "permission_group_users:manage";
    PermissionsEnum["OrganizationNotesManagement"] = "notes_for_organization:manage";
    PermissionsEnum["ManageCustomPlan"] = "custom_plan:manage";
    PermissionsEnum["ProductsManage"] = "products:manage";
    return PermissionsEnum;
}({});
